import { ShipyardService } from 'src/app/modules/shipyard/shipyard.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/components/dialogs/confirm-dialog/confirm-dialog.component';
import { GridActionsService } from 'src/app/data-grid/grid-actions.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-multi-shipyard-panel',
  templateUrl: './multi-shipyard-panel.component.html',
  styleUrls: ['./multi-shipyard-panel.component.scss']
})
export class MultiShipyardPanelComponent implements OnInit,OnDestroy {
  _selectedSkus: any;
  get selectedSkus() {
    return this._selectedSkus;
  }
  @Input() set selectedSkus(value) {
    this._selectedSkus = value;
    const len=this.selectedSkus.length;
    this.shipmentType.setValue(
      this.shipyardService.getShipmentTypeId(this.selectedSkus[len - 1].FbaType)
    );
  }
  shipmentType = new FormControl();
  fbaTypes;
  private destroy$ = new Subject<void>();
  @Input() isWalmartAccount:boolean=false;

  constructor(
    private dialog: MatDialog,
    private gridActionsService: GridActionsService,
    private shipyardService: ShipyardService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.fbaTypes = this.shipyardService.getAllShipmentTypes();
  }
  
  updateFbaType() {    
    this.dialog
    .open(ConfirmDialogComponent, {
      width: "600px",
      data: {
        title: "Update FBA Type",
        message: "Are you sure you want to update FBA Type?",
      },
    })
    .afterClosed()
    .subscribe((res) => {      
      if (res === "Confirm"){
        this.gridActionsService.updateFbaType(this.selectedSkus, this.shipmentType) 
      }else{
        this.shipmentType.setValue(
          this.shipyardService.getShipmentTypeId(this.selectedSkus[this.selectedSkus.length-1].FbaType));
      }
    });
  }
}
